import { Checkbox, Form, Radio, Select, TimePicker } from "antd";
import { FC } from "react";
import { useGetAllStaff } from "~/services/operation";
import { useGetTeams } from "~/services/team";
import { capitalize } from "~/utils";
import { PreferredCommunicationMethod } from "~/utils/constants";

const { Option } = Select;

type Props = {};

export const TabPreferences: FC<Props> = () => {
  const { data: staffs, isLoading: isLoadingStaff } = useGetAllStaff();
  const { data: teams, isLoading: isLoadingTeam } = useGetTeams();

  return (
    <div>
      <h2 className="text-xl font-semibold mb-6">Client Preferences</h2>

      <div className="space-y-6">
        {/* Notification Preferences */}
        <div className="p-4 border rounded-lg bg-gray-50">
          <h3 className="font-medium mb-4">Notification Preferences</h3>
          <div className="grid grid-cols-1 gap-4">
            <Form.Item
              name="preferredCommunicationMethod"
              label="Preferred Communication Method"
            >
              <Radio.Group
                options={Object.values(PreferredCommunicationMethod).map(
                  (method) => ({
                    label: capitalize(method),
                    value: method,
                  })
                )}
              />
            </Form.Item>

            <Form.Item
              name="serviceNotifications"
              label="Service Notifications (check all that apply)"
            >
              <Checkbox.Group className="grid grid-cols-3 gap-2">
                <Checkbox value="1WeekBefore">1 Week Before</Checkbox>
                <Checkbox value="3DaysBefore">3 Days Before</Checkbox>
                <Checkbox value="DayBefore">Day Before</Checkbox>
                <Checkbox value="DayOfService">Day of Service</Checkbox>
                <Checkbox value="ServiceCompletion">
                  Service Completion
                </Checkbox>
                <Checkbox value="BookingConfirmation">
                  Booking Confirmation
                </Checkbox>
              </Checkbox.Group>
            </Form.Item>
          </div>
        </div>

        {/* Staff Preferences */}
        <div className="p-4 border rounded-lg bg-gray-50">
          <h3 className="font-medium mb-4">Staff Preferences</h3>
          <div className="grid grid-cols-2 gap-4">
            <Form.Item name="teamId" label="Preferred Handler Team">
              <Select placeholder="No preference" loading={isLoadingTeam}>
                <Option value="">No preference</Option>
                {teams?.items.map((team) => (
                  <Option key={team.id} value={team.id}>
                    {team.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="staffIds" label="Avoid Staff Members">
              <Select
                placeholder="Select staff to avoid"
                mode="multiple"
                allowClear
                loading={isLoadingStaff}
              >
               {staffs?.items
  .filter(staff => staff && staff.id) // Filter out any null staff
  .map((staff) => (
    <Option key={staff.id} value={staff.id}>
      {staff.user 
        ? `${staff.user.first_name || ''} ${staff.user.last_name || ''}`.trim() || `Staff ${staff.id.slice(0, 8)}`
        : `Staff ${staff.id.slice(0, 8)}`}
    </Option>
  ))}
              </Select>
            </Form.Item>
          </div>
        </div>

        {/* Timing Preferences */}
        <div className="p-4 border rounded-lg bg-gray-50">
          <h3 className="font-medium mb-4">Timing Preferences</h3>
          <div className="grid grid-cols-2 gap-4">
            <Form.Item name="preferredDays" label="Preferred Days">
              <Checkbox.Group className="flex flex-wrap gap-2">
                {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map(
                  (day) => (
                    <Checkbox key={day} value={day}>
                      {day}
                    </Checkbox>
                  )
                )}
              </Checkbox.Group>
            </Form.Item>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Preferred Time Window
              </label>
              <div className="grid grid-cols-2 gap-2">
                <Form.Item
                  name="preferredTimeWindowFrom"
                  label={<span className="text-xs">From</span>}
                  labelCol={{ span: 24 }}
                >
                  <TimePicker
                    format="HH:mm"
                    className="w-full"
                    placeholder="From"
                  />
                </Form.Item>
                <Form.Item
                  name="preferredTimeWindowTo"
                  label={<span className="text-xs">To</span>}
                  labelCol={{ span: 24 }}
                >
                  <TimePicker
                    format="HH:mm"
                    className="w-full"
                    placeholder="To"
                  />
                </Form.Item>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
